export default "__VITE_ASSET__2547d0ac__"